var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42,
    zoomAndPan: "magnify",
    viewBox: "0 0 750 749.999995",
    height: 42,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "2a8cd8d524"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 150.527344 150 L 587 150 L 587 587 L 150.527344 587 Z M 150.527344 150 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2a8cd8d524)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 537.9375 231.285156 L 584.1875 193.84375 L 584.925781 320.710938 L 460.933594 293.585938 L 507.179688 256.246094 C 445.128906 179.714844 332.828125 167.957031 256.335938 229.839844 C 179.742188 291.832031 167.972656 404.0625 229.910156 480.582031 C 291.953125 557.023438 404.265625 568.878906 480.859375 506.882812 C 528.664062 468.199219 551.257812 409.820312 546.316406 352.789062 L 576.441406 359.390625 L 586.457031 361.554688 C 588.519531 427.246094 560.851562 493.074219 505.726562 537.617188 C 412.210938 613.320312 274.917969 598.980469 199.152344 505.429688 C 123.378906 411.984375 137.726562 274.8125 231.355469 199.109375 C 324.882812 123.398438 462.175781 137.734375 537.929688 231.285156 Z M 388.367188 229.738281 L 388.367188 360.214844 L 472.507812 444.171875 L 444.417969 472.238281 L 348.726562 376.613281 L 348.726562 229.738281 Z M 388.367188 229.738281 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderHistory);
export default __webpack_public_path__ + "static/media/order-history.b2041b2e5ad8656ba00ab72c2743f3d1.svg";
export { ForwardRef as ReactComponent };